import React, { useEffect } from 'react';
import getContent, { init as initL10n } from 'pp-react-l10n';
import { MISC } from '../../client/lib/constants';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getHost } from '../../lib/host';
import { recordImpression } from '@paypalcorp/fpti-tracker';

initL10n({
  content: (() => {
    if (typeof window !== 'undefined' && window.dictionary) {
      return window.dictionary;
    }
    if (typeof global !== 'undefined' && global.dictionary) {
      return global.dictionary;
    }
    return {};
  })(),
  onContentMissing: () => {}
});

const getNotFoundContent = getContent('merchanthub.notFound');

const NotFound = ({ location: { pathname = '' }, staticContext = {} }) => {
  const recordAppCenter404Impression = () => {
    const container = {
        pgrp: 'main:merchanthub:appcenter:main',
        page: 'main:merchanthub:appcenter:main:pagenotfound'
      },
      optionsObj = {
        erpg: 'Page Not Found',
        eccd: '404'
      };

    recordImpression(optionsObj, container);
  };

  useEffect(() => {
    //TODO: we should also have a case for the old tools page
    if (pathname.includes('appcenter')) {
      recordAppCenter404Impression();
    }
  }, []);

  if (pathname.includes(MISC.SELL)) {
    return <Redirect to="/sell" />; // sets 302 status in RouteMatch.js
  } else if (staticContext?.req?.user) {
    staticContext.url = '/mep/dashboard';
  }
  staticContext.status = 404;
  return (
    <div className="notfound-container">
      <h1>{getNotFoundContent('title')}</h1>

      <div>
        <p>{getNotFoundContent('description')}</p>

        {getNotFoundContent('suggestions', {
          sitemapLink: (
            <a href={`${getHost()}/webapps/mpp/full-sitemap`}>
              {getNotFoundContent('sitemap')}
            </a>
          ),
          searchLink: (
            <a href={`${getHost()}/smarthelp/home`}>
              {getNotFoundContent('search')}
            </a>
          ),
          startOverLink: (
            <a href={`${getHost()}/merchantapps/appcenter`}>
              {getNotFoundContent('startOver')}
            </a>
          )
        })}
      </div>
    </div>
  );
};

export default NotFound;

NotFound.propTypes = {
  location: PropTypes.object,
  staticContext: PropTypes.object
};
